import React, { useState } from "react";

const Announcement = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="alert alert-info alert-dismissible fade show text-center" role="alert">
  <span role="img" aria-label="rocket">🚀</span> <strong>Update: VoiceLoop for iOS is Taking Off!</strong>
  <p className="mb-0 mt-2">
    Following my last notice, I've been hard at work developing the native VoiceLoop mobile app for a seamless experience on Apple devices.
    <br />
    I'm excited to share a first look at my progress. Check out my new video demonstrating the upcoming features.
    <br /><br />
    <strong><a href="https://youtu.be/7ScAWnhxZbU?si=Cu1UMm-5BIFUTo13" target="_blank" rel="noopener noreferrer">View the iOS Development Preview on YouTube</a></strong>
    <br /><br />
    Thank you for your patience and support as I build a better VoiceLoop for you.
    <br />
    <span role="img" aria-label="mailbox">📬</span> Questions? <a href="/contact" target="_blank" rel="noopener noreferrer">Contact me here</a>.
  </p>
  <button type="button" className="btn-close" aria-label="Close" onClick={() => setIsVisible(false)}></button>
</div>
  );
};

export default Announcement;
